import { Link } from "react-router-dom";

export const EnglishForCareerAndInternationalCommunicationConst = {
  path: "/single-page/english-for-career-and-international-communication",
  title: "АНГЛИЙСКИЙ ДЛЯ КАРЬЕРЫ И МЕЖДУНАРОДНОГО ОБЩЕНИЯ",
  contentJSX: (
    <>
      <h2>Английский для карьеры и международного общения</h2>
      <p>Общий объём: 144 академических часа</p>
      <p>Формат: онлайн / офлайн / гибрид</p>
      <p>Язык: английский (поддержка на русском и узбекском)</p>
      <p>Итог: Международный сертификат</p>
      <h2>I. АКАДЕМИЧЕСКИЙ АНГЛИЙСКИЙ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Writing: abstracts, papers, proposals – 12 ч</li>
        <li>Reading: научная и методическая литература – 12 ч</li>
        <li>Listening: лекции, подкасты, конференции – 12 ч</li>
      </ul>
      <h2>II. ОРАТОРСКОЕ МАСТЕРСТВО И ПРЕЗЕНТАЦИИ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Навыки публичных выступлений – 12 ч</li>
        <li>Использование визуальных и интерактивных материалов – 6 ч</li>
        <li>TED-style презентации и защита проектов – 12 ч</li>
      </ul>
      <h2>III. ДЕЛОВОЕ И ПРОФЕССИОНАЛЬНОЕ ОБЩЕНИЕ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Email, письма, деловая переписка – 6 ч</li>
        <li>Видеозвонки, Zoom, переговоры – 6 ч</li>
        <li>Small talk и networking – 6 ч</li>
        <li>Командное взаимодействие – 6 ч</li>
        <li>Кросс-культурная коммуникация – 6 ч</li>
      </ul>
      <h2>IV. EMI (ENGLISH MEDIUM INSTRUCTION) — 24 ЧАСА</h2>
      <ul className="number">
        <li>Методика преподавания на английском – 12 ч</li>
        <li>Лексика и структура лекций – 6 ч</li>
        <li>Вовлечение студентов и интерактив – 6 ч</li>
      </ul>
      <h2>V. ИТОГОВАЯ АТТЕСТАЦИЯ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Презентация курса, проекта или отчёта – 12 ч</li>
        <li>Тестирование и обратная связь – 12 ч</li>
      </ul>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    Английский для карьеры и международного общения 
    Общий объём: 144 академических часа
    Формат: онлайн / офлайн / гибрид
    Язык: английский (поддержка на русском и узбекском)
    Итог: Международный сертификат
    I. АКАДЕМИЧЕСКИЙ АНГЛИЙСКИЙ — 36 ЧАСОВ
    Writing: abstracts, papers, proposals – 12 ч
    Reading: научная и методическая литература – 12 ч
    Listening: лекции, подкасты, конференции – 12 ч
    II. ОРАТОРСКОЕ МАСТЕРСТВО И ПРЕЗЕНТАЦИИ — 30 ЧАСОВ
    Навыки публичных выступлений – 12 ч
    Использование визуальных и интерактивных материалов – 6 ч
    TED-style презентации и защита проектов – 12 ч
    III. ДЕЛОВОЕ И ПРОФЕССИОНАЛЬНОЕ ОБЩЕНИЕ — 30 ЧАСОВ
    Email, письма, деловая переписка – 6 ч
    Видеозвонки, Zoom, переговоры – 6 ч
    Small talk и networking – 6 ч
    Командное взаимодействие – 6 ч
    Кросс-культурная коммуникация – 6 ч
    IV. EMI (ENGLISH MEDIUM INSTRUCTION) — 24 ЧАСА
    Методика преподавания на английском – 12 ч
    Лексика и структура лекций – 6 ч
    Вовлечение студентов и интерактив – 6 ч
    V. ИТОГОВАЯ АТТЕСТАЦИЯ — 24 ЧАСА
    Презентация курса, проекта или отчёта – 12 ч
    Тестирование и обратная связь – 12 ч
  `,
};
